import request from "./request";

export default class ConsultationRecordApi {
  /**
   * 搜索问诊记录
   */
  public static getRecord = (
    state: number | undefined,
    patientName: string,
    startTime: string | null,
    endTime: string | null,
    pageNumber: number,
    doctorId: string,
    revisitStatus?: string
  ) => {
    return request({
      url: "/api/v1/consultation/record",
      method: "GET",
      params: {
        state,
        patientName,
        startTime,
        endTime,
        pageNumber,
        pageSize: 10,
        doctorId,
        revisitStatus,
      },
    });
  };

  /**
   * 问诊详情
   */
  public static getRecordDetails = (recordId: string) => {
    return request({
      url: `/api/v1/consultation/${recordId}`,
      method: "GET",
    });
  };

  /**
   * 删除问诊记录
   */
  public static deleteRecord = (recordId: string) => {
    return request({
      url: `/api/v1/consultation/doctor/${recordId}`,
      method: "DELETE",
    });
  };

  /**
   * 医生提交诊断结果
   */
  public static doctorSetDiagnosis = (
    recordId: string,
    patientVisible: boolean,
    dialectical: string,
    fourDiagnosis: string = "",
    analysis: string = "",
    prescription: string = ""
  ) => {
    return request({
      url: `/api/v1/consultation/result`,
      method: "POST",
      data: {
        recordId,
        patientVisible,
        dialectical,
        fourDiagnosis,
        analysis,
        prescription,
      },
    });
  };

  /**
   * 开药
   */
  public static issuePrescription = (recordId: string, prescriptionTime: string) => {
    return request({
      url: `/api/v1/consultation/prescription`,
      method: "POST",
      data: { recordId, prescriptionTime },
    });
  };

  /**
   * 获取上次就诊症状信息
   */
  public static getLastSymptom = (recordId: string) => {
    return request({
      url: `/api/v1/consultation/symptom/${recordId}`,
      method: "GET",
    });
  };

  /**
   * 复诊
   */
  public static issueRevisit = (recordId: string) => {
    return request({
      url: `/api/v1/consultation/revisit/${recordId}`,
      method: "POST",
    });
  };

  /**
   * 获取复诊提醒人数
   */
  public static getDoctorRevisitNum = (doctorId: string) => {
    return request({
      url: `/api/v1/consultation/getDoctorRevisitNum/${doctorId}`,
      method: "GET",
    });
  };

  /**
   * 获取看诊统计数据
   */
  public static getDoctorDashboard = (
    doctorId: string,
    startTime: string,
    endTime: string
  ) => {
    return request({
      url: "/api/v1/consultation/doctor/dashboard",
      method: "GET",
      params: { doctorId, startTime, endTime },
    });
  };

  /**
   * 获取阿里云上传地址
   */
  public static getOssUrl = () => {
    return request({
      url: "/api/v1/aliyun/oss",
      method: "GET",
      params: {
        type: "picture",
      },
    });
  };

  /**
   * 获取阿里云地址访问前缀
   */
  public static getOssHost = () => {
    return request({
      url: "/api/v1/aliyun/url/prefix",
      method: "GET",
    });
  };
}
